module.exports = __webpack_public_path__ + "img/暂无图片.5f74d522.png";